// extracted by mini-css-extract-plugin
module.exports = {"loaderMessage":"InfinityScrollWrapper_loaderMessage__OEJeV","emptyMessage":"InfinityScrollWrapper_emptyMessage__3uLW8"};